<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>选择付款方式</span>
    </div>
    <div class="box-content">
      <div class="payType">
        <div class="item" :class="subPayType=='2'?'active':''" @click="changePayType('2')"><span>支付宝</span></div>
        <div class="item" :class="subPayType=='1'?'active':''"  @click="changePayType('1')"><span>微信支付</span></div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ["payType"],
  data() {
    return {
      subPayType: this.payType
    };
  },
  methods: {
    changePayType(value) {
      this.subPayType = value;
      this.$emit("changePayType", value);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.box-card {
  margin-top: 10px;
}
.box-content .payType {
  display: flex;
}
.box-content .payType .item{
  width:140px;
  border:solid #efefef 1px;
  line-height: 43px;
  margin-right: 50px;
  border-radius: 5px;
  padding-left: 45px;
  position: relative;
  cursor: pointer;
}
.box-content .payType .item span:before{
  display: inline-block;
  position: absolute;
  width:32px;
  height:32px;
  content: "";
  background: url(../../../assets/image/pay_bg.png) 0 -2px no-repeat;
  background-size:100px; 
  left:8px;
  top:5px;
}
.box-content .payType .item:nth-child(2) span:before{
  background-position: -38px -2px;
}
.box-content .payType .item:before{
  position: absolute;
  width:20px;
  height:20px;
  content: "";
  border:solid #efefef 1px;
  right:6px;
  top:10px;
}
.box-content .payType .active:before{
  width:25px;
  height:25px;
  border:0;
  background: url(../../../assets/image/pay_bg.png) -75px -6px no-repeat;
  background-size:100px;
}
</style>
